module.exports = __webpack_public_path__ + "img/contactbtn.b4d7802a.png";